export const routes = (parentName) => {
  return [
    {
      path: "gldtogld",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-Gldtogld`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: "orders",
          name: `${parentName}-Gldtogld-Gateway`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },

        {
          path: ":id",
          name: parentName + "-" + "Gldtogld-View",
          component: () => import("./View.vue"),
        },
      ],
    },
  ];
};
